module.exports = __webpack_public_path__ + "img/news_banner.70eb34ea.png";